
import { Vue, Component } from "vue-property-decorator";
import Slick from "vue-slick";
@Component({
  components: {
    Slick,
  },
})
export default class Calender extends Vue {
  private availableDates: any[] = [];
  date = "";
  currentIndex = -1;
  $refs!: any;
  private sliderOptions: any = {
    slidesToShow: 5,
    slidesToScroll: 5,
    infinite: false,
  };

  mounted() {
    this.getNextTenDays();
  }
  getNextTenDays() {
    let startDate = new Date();
    for (let i = 1; i <= 10; i++) {
      let x = new Date();
      x.setDate(startDate.getDate() + i);
      const dateComponent = x.toString().split(" ");
      this.availableDates.push({
        day: dateComponent[0],
        month: dateComponent[1],
        date: dateComponent[2].replace(/^0+/, ''),
      });
    }
  }
  setDate(idx: number) {
    this.date = "";
    this.currentIndex = idx;
    const dateSelected = this.availableDates[idx];
    this.date = `${dateSelected.day} ${dateSelected.month}/${dateSelected.date}`;
  }

}
